import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import TableWithContainer from "utils/Table/TableWithContainer";

export default function PreviouslyInsured(props) {
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const headers = [[
        props.type == "Quotes" ? "Quote Type" : "Policy Type",
        props.type,
        "Yes (%)",
        "No (%)",
        "Not Answered (%)"
    ]];

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", `/Home/Get${props.type}PreviouslyInsured`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            getQuoteType: props.getQuoteType
        });

        if (response) {
            const formattedResponse = response.map((row) => [
                row.policyType || row.quoteType,
                integer.format(row.policies || row.quotes),
                percent.format(row.yesPercentage / 100),
                percent.format(row.noPercentage / 100),
                percent.format(row.notAnsweredPercentage / 100),
            ]);

            if (props.comments?.length > 0) {
                headers[0].push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row.toLowerCase() == x[0].toLowerCase());
                    x.push(comment ? comment.message : '');
                });
            }

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                title={`${props.type.toUpperCase()} - PREVIOUSLY INSURED`}
                loading={loading}
                fixedColumns={1}
                style={{
                    Table: {
                        TableSX: { tableLayout: 'fixed' }, // all columns same width
                    }
                }}
                headers={headers}
                rows={data.filter(x => x[0] !== 'TOTAL')}
                footers={data.filter(x => x[0] === 'TOTAL')}
                exportName={`${props.type}PreviouslyInsured`}
            />
        </div>
    );
};
